export default "__VITE_ASSET__y669bdaU__"